import { Button } from '@spiaggeit/spit-ui'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '@/hooks/store'
import { useTriggerClick } from '@/hooks/timeSchedule/useTriggerClick'
import { Service } from '@/models/service'
import { cartSlice } from '@/store/cartSlice'
import { serviceQuantitySelector } from '@/store/cartSlice/selectors/serviceQuantitySelector'
import { dayDifferenceSelector } from '@/store/insertPeriodSlice'
import { timeScheduleSlice } from '@/store/timeScheduleSlice'
import { TimeScheduleDialog } from '.'

type Props = {
  ticket: Service
}

export function TimeScheduleDialogTrigger(props: Props) {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const cartReservations = useAppSelector(cartSlice.selectors.cartReservations)
  const dayDifference = useAppSelector(dayDifferenceSelector)
  const quantity = useAppSelector((state) =>
    serviceQuantitySelector(state, props.ticket)
  )
  const service = useAppSelector(timeScheduleSlice.selectors.service)

  const ticketReservation = useMemo(
    () =>
      cartReservations.find((r) => r.spotName === null && r.spotType === null),
    [cartReservations]
  )

  const isEdit = quantity !== 0

  const { onTriggerClick } = useTriggerClick({
    isEdit,
    reservation: ticketReservation,
    service: props.ticket,
  })

  const triggerLabel = useMemo(() => {
    if (dayDifference === 1) {
      return t(
        isEdit
          ? 'timeSchedulesDialog.triggerEditSingleDay'
          : 'timeSchedulesDialog.triggerSelectSingleDay'
      )
    }

    return t(
      isEdit
        ? 'timeSchedulesDialog.triggerEdit'
        : 'timeSchedulesDialog.triggerSelect'
    )
  }, [isEdit, dayDifference])

  return (
    <>
      <Button
        className="grow rounded"
        onClick={onTriggerClick}
        type="button"
        variant="outline"
      >
        {triggerLabel}
      </Button>

      {service?.serviceId === props.ticket.serviceId ? (
        <TimeScheduleDialog
          {...props}
          onClose={() => dispatch(timeScheduleSlice.actions.reset())}
        />
      ) : null}
    </>
  )
}
